import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Paper, TextField, Typography } from "@material-ui/core";
import useStyles from "../../styles/styles";
import SensitiveField from "../Fields/SensitiveField";

const BankInformation = ({
    bankName,
    routingNumber,
    accountNumber,
    accountType,
    monthsAtBank,
}) => {
    const classes = useStyles();
    return (
        <>
            <Typography variant="h4" component="h4" align="left">Bank Information</Typography>
            <Paper className={classes.paper}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8} lg={3}>
                        <TextField label="Bank Name" value={bankName} readOnly fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={4} lg={2}>
                        <TextField label="Months at Bank" value={monthsAtBank} readOnly fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={8} md={4} lg={2}>
                        <TextField label="Account Type" value={accountType} readOnly fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <TextField label="Routing Number" value={routingNumber} readOnly fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <SensitiveField label="Account Number" value={accountNumber} />
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
};

BankInformation.propTypes = {
    bankName: PropTypes.string.isRequired,
    routingNumber: PropTypes.string.isRequired,
    accountNumber: PropTypes.string.isRequired,
    accountType: PropTypes.string.isRequired,
    monthsAtBank: PropTypes.number,
};

BankInformation.defaultProps = {
    monthsAtBank: null,
}

export default BankInformation
